import { useEffect } from "react";
import { requestFcmToken, onMessageListener } from "../../config/firebase";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { user_subscribe_notification } from "../../reduxData/user/userAction";
import { get_user_all_notifications } from "../../reduxData/Notifications/notificationActions";

export const useAdminMessaging = (user) => {
    const dispatch = useDispatch();
    const { accessToken } = useSelector((state) => state.auth);

    // subscribe notification and fetch notifications listing
    useEffect(() => {
        if (!user) return;
        const init = async () => {
            const token = await requestFcmToken();
            if (!token) return;
            await user_subscribe_notification(
                { deviceToken: token, topics: ["dispute_admin"] },
                dispatch
            );
        };

        init();

        const unsubscribe = onMessageListener((payload) => {
            const message = `${payload.notification.title} - ${payload.notification.body}`;
            if (toast.isActive("bid-toast")) {
                toast.update("bid-toast", { render: message, type: "success", autoClose: 3000, });
            } else {
                toast.success(message, { toastId: "bid-toast", autoClose: 3000, });
            }

            get_user_all_notifications(dispatch);
        });

        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [user]);
};